import React from 'react';
import { ArrowsRightLeftIcon } from '@heroicons/react/20/solid';
import FormButton from '@ui/button/FormButton';
import { compareOn } from './compareSwitch';

type Props = {
	// The address query of the report: the comparison starts with its scope, period and switches (D3).
	search: string,
	// The count of the properties that the user can read in BI: the button shows from 2 (D12).
	properties: number,
};

// "Compare properties" in the header of a BI report (BI Property comparison, D3, D12): it opens the same report as a
// comparison. It shows for a user who can read 2 or more BI properties, while the comparison is on (compareSwitch).
const CompareButton: React.FunctionComponent<Props> = ({ search, properties }) => {
	if (!compareOn() || properties < 2) return null;
	return <FormButton state="white" to={`/secured/bi/compare/segmentation${search === '' ? '' : `?${search}`}`}
		icon={<ArrowsRightLeftIcon aria-hidden="true" className="h-4 w-4 text-gray-500" />}>Compare properties</FormButton>;
};

export default CompareButton;
